export default __webpack_public_path__ + "locales/lo-LA/EmptyTrashDialog.json?hash=6cc953ddd521b169afbdd8675195a8db";